import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BASE_PATH } from "@kelyn-technologies/dsio-angular-lib/dsio-api";

export interface DeleteTenantResponse {
  message: string;
  tenant_id: string;
}

@Injectable({
  providedIn: "root",
})
export class TenantCleanupService {
  constructor(
    private http: HttpClient,
    @Inject(BASE_PATH) private basePath: string
  ) {}

  deleteTenant(tenantId: string): Observable<DeleteTenantResponse> {
    const encodedTenantId = encodeURIComponent(tenantId);
    return this.http.delete<DeleteTenantResponse>(
      `${this.basePath}/tenants/${encodedTenantId}`
    );
  }
}
